module.exports = __webpack_public_path__ + "static/b1-rtjposter-dd8c4710f8fcd07bc87bb78e4b0fda11.jpg";